<div class="d-flex order-lg-2 header-right-icons header-search-icon">
  <div class="navbar navbar-collapse responsive-navbar p-0">
    <div
      class="collapse navbar-collapse collapse-horizontal"
      id="navbarSupportedContent-4"
      #collapse="ngbCollapse"
      [(ngbCollapse)]="isCollapsed"
      [horizontal]="true"
    >
      <div class="d-flex align-items-center">
        @if (role != 'User') {
          <div ngbDropdown class="d-flex profile-1 drawerIcon">
            <a ngbDropdownToggle data-bs-toggle="dropdown" class="nav-link icon caret pointer me-3">
              <img src="assets/icons/ic_grid.svg" alt="Drawer icon" />
            </a>

            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
              <div class="dropdownLink p-4">
                <h5 class="fw-600">App Hub</h5>
                <div class="d-flex">
                  <div class="col">
                    <a
                      (click)="onToggleAdminMode(1)"
                      class="appHubIcon d-flex flex-column align-items-center justify-content-center"
                      aria-label="Open folder"
                    >
                      <div class="imgbox middle mb-2">
                        <img src="assets/images/icon/switch-admin.svg" alt="chat Admin" />
                      </div>
                      <span class="appHubText text-center">FieldQ Admin</span>
                    </a>
                  </div>
                  <div class="col">
                    <a
                      (click)="onToggleAdminMode(0)"
                      class="appHubIcon d-flex flex-column align-items-center justify-content-center"
                      aria-label="Open folder"
                    >
                      <div class="imgbox middle mb-2">
                        <img src="assets/images/icon/switch-chat.svg" alt="chat Admin" />
                      </div>
                      <span class="appHubText text-center">FieldQ Chat</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <div ngbDropdown class="dropdown profile-1 d-flex prfUser">
          <a
            ngbDropdownToggle
            class="pointer"
            data-bs-toggle="dropdown"
            class="nav-link icon d-flex"
          >
            <div class="iconBox"></div>
            <div class="right">
              <span class="userName">{{ userInfo?.name || '' }}</span>
            </div>
          </a>
          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
            <div class="dropdownLink">
              <a ngbDropdownItem (click)="onSignOut()" aria-label="Open folder">Logout </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<svg xmlns="http://www.w3.org/2000/svg" style="display: none">
  <!-- Info Icon -->
  <symbol id="drawer-icon" width="52" height="52" viewBox="0 0 52 52">
    <rect width="51.8679" height="52" rx="25.934" fill="#F4F4F4" />
    <path
      d="M20.5622 16.75C19.5346 16.75 18.549 17.1582 17.8224 17.8849C17.0957 18.6115 16.6875 19.5971 16.6875 20.6247C16.6875 21.6524 17.0957 22.6379 17.8224 23.3646C18.549 24.0912 19.5346 24.4994 20.5622 24.4994C21.0711 24.4994 21.5749 24.3992 22.045 24.2045C22.5151 24.0098 22.9423 23.7244 23.3021 23.3646C23.6619 23.0048 23.9473 22.5776 24.142 22.1075C24.3367 21.6374 24.4369 21.1336 24.4369 20.6247C24.4369 20.1159 24.3367 19.612 24.142 19.1419C23.9473 18.6718 23.6619 18.2447 23.3021 17.8849C22.9423 17.5251 22.5151 17.2397 22.045 17.045C21.5749 16.8502 21.0711 16.75 20.5622 16.75Z"
      stroke="#006BFF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M31.3123 16.75C30.2846 16.75 29.2991 17.1582 28.5724 17.8849C27.8458 18.6115 27.4375 19.5971 27.4375 20.6247C27.4375 21.6524 27.8458 22.6379 28.5724 23.3646C29.2991 24.0912 30.2846 24.4994 31.3123 24.4994C31.8211 24.4994 32.325 24.3992 32.7951 24.2045C33.2652 24.0098 33.6923 23.7244 34.0521 23.3646C34.4119 23.0048 34.6973 22.5776 34.892 22.1075C35.0868 21.6374 35.187 21.1336 35.187 20.6247C35.187 19.5971 34.7788 18.6115 34.0521 17.8849C33.3255 17.1582 32.3399 16.75 31.3123 16.75Z"
      stroke="#006BFF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.5622 27.5C19.5346 27.5 18.549 27.9083 17.8224 28.6349C17.0957 29.3616 16.6875 30.3471 16.6875 31.3748C16.6875 32.4024 17.0957 33.388 17.8224 34.1146C18.549 34.8413 19.5346 35.2495 20.5622 35.2495C21.0711 35.2495 21.5749 35.1493 22.045 34.9545C22.5151 34.7598 22.9423 34.4744 23.3021 34.1146C23.6619 33.7548 23.9473 33.3277 24.142 32.8576C24.3367 32.3875 24.4369 31.8836 24.4369 31.3748C24.4369 30.8659 24.3367 30.3621 24.142 29.892C23.9473 29.4219 23.6619 28.9947 23.3021 28.6349C22.9423 28.2751 22.5151 27.9897 22.045 27.795C21.5749 27.6003 21.0711 27.5 20.5622 27.5Z"
      stroke="#006BFF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M31.3123 27.5C30.2846 27.5 29.2991 27.9083 28.5724 28.6349C27.8458 29.3616 27.4375 30.3471 27.4375 31.3748C27.4375 32.4024 27.8458 33.388 28.5724 34.1146C29.2991 34.8413 30.2846 35.2495 31.3123 35.2495C32.3399 35.2495 33.3255 34.8413 34.0521 34.1146C34.7788 33.388 35.187 32.4024 35.187 31.3748C35.187 30.3471 34.7788 29.3616 34.0521 28.6349C33.3255 27.9083 32.3399 27.5 31.3123 27.5Z"
      stroke="#006BFF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </symbol>

  <!-- notifications -->
  <symbol id="notification-icon" width="52" height="53" viewBox="0 0 52 53" fill="none">
    <g clip-path="url(#clip0_248_6867)">
      <path
        d="M26 53C40.3594 53 52 41.1355 52 26.5C52 11.8645 40.3594 0 26 0C11.6406 0 0 11.8645 0 26.5C0 41.1355 11.6406 53 26 53Z"
        fill="#FFF9F8"
      />
      <path
        d="M25.8974 21.44V24.77M25.9174 17C22.2374 17 19.2574 19.98 19.2574 23.66V25.76C19.2574 26.44 18.9774 27.46 18.6274 28.04L17.3574 30.16C16.5774 31.47 17.1174 32.93 18.5574 33.41C23.3386 35 28.5061 35 33.2874 33.41C33.6029 33.3048 33.8907 33.13 34.1295 32.8986C34.3684 32.6672 34.5522 32.385 34.6674 32.073C34.7826 31.761 34.8263 31.4271 34.7951 31.096C34.7639 30.7649 34.6588 30.445 34.4874 30.16L33.2174 28.04C32.8674 27.46 32.5874 26.43 32.5874 25.76V23.66C32.5774 20 29.5774 17 25.9174 17Z"
        stroke="#006BFF"
        stroke-width="2.2"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M29.2303 35C29.2303 36.83 27.7303 38.33 25.9003 38.33C24.9903 38.33 24.1503 37.95 23.5503 37.35C22.9503 36.75 22.5703 35.91 22.5703 35"
        stroke="#006BFF"
        stroke-width="2.2"
        stroke-miterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_248_6867">
        <rect width="52" height="53" fill="white" />
      </clipPath>
    </defs>
  </symbol>
</svg>
